import { Button, Modal, TextField, FormLayout, Form, Checkbox, Text, LegacyStack } from '@shopify/polaris';
import { useState, useCallback, useEffect } from 'react';
import { listPermissions } from '../../../services/rolesService';

export const NewRoleModal = ({ onAddRole }) => {
  const [active, setActive] = useState(false);
  const handleClose = useCallback(() => setActive(!active), [active]);

  const defaultForm = {
    name: '',
    slug: '',
    permissions: [],
  };
  const [newRoleForm, setNewRoleForm] = useState(defaultForm);
  const [permissions, setPermissions] = useState([]);

  const activator = (
    <Button onClick={handleClose} primary="primary" size="slim">
      Nuevo rol
    </Button>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onAddRole(newRoleForm);
      setNewRoleForm(defaultForm);
      setActive(false);
    } catch (e) {}
  };

  const handleChange = (permit) => {
    const newPermits = newRoleForm.permissions.includes(permit)
      ? newRoleForm.permissions.filter((p) => p !== permit)
      : [...newRoleForm.permissions, permit];
    setNewRoleForm({ ...newRoleForm, permissions: newPermits });
  };

  useEffect(() => {
    listPermissions().then((res) => {
      setPermissions(res.data.permissions);
    });
    return () => {
      setPermissions([]);
      setNewRoleForm(defaultForm);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Modal
      activator={activator}
      open={active}
      onClose={handleClose}
      title="Crear nuevo rol"
      primaryAction={{
        content: 'Crear',
        onAction: handleSubmit,
      }}
    >
      <Modal.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <TextField
              label="Nombre"
              type="name"
              value={newRoleForm.name}
              autoComplete="  off"
              onChange={(e) => {
                setNewRoleForm({
                  ...newRoleForm,
                  name: e,
                });
              }}
            />
            <TextField
              label="Slug"
              type="slug"
              value={newRoleForm.slug}
              autoComplete="off"
              onChange={(e) =>
                setNewRoleForm({
                  ...newRoleForm,
                  slug: e,
                })
              }
            />

            {permissions &&
              permissions.map((permission, k) => (
                <Permission key={k} permission={permission} newRoleForm={newRoleForm} handleChange={handleChange} />
              ))}
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
};

const Permission = ({ permission, newRoleForm, handleChange }) => (
  <>
    <Text variant="headingXs">{permission.title}</Text>
    <LegacyStack distribution="leading">
      {permission.permissions.map((p) => (
        <Checkbox
          checked={newRoleForm.permissions.includes(`${permission.domain}:${p}`)}
          onChange={() => handleChange(`${permission.domain}:${p}`)}
          label={p}
        ></Checkbox>
      ))}
    </LegacyStack>
  </>
);
